import { Link,graphql, useStaticQuery } from "gatsby"
import React from "react"

 const languageIds = require("../dic/ids.json");

const Footer = ({langPage}) => {
  const data = useStaticQuery(
    graphql`{
      allWpPage(filter: {databaseId: {in: [259]}}) {
       edges {
         node {
           databaseId
           title
           page_content {
             contentRaw
           }
         }
       }
      }
    }
    `
  );

  var footer= null;
  for(var i in data.allWpPage.edges){
    if(data.allWpPage.edges[i].node.databaseId===languageIds[langPage].footer){
        footer=data.allWpPage.edges[i].node;
        break;
    }
  }

  return (
  <footer>
    <div className="container">
      {footer!=null
      ?
      <div className="innerFooter" dangerouslySetInnerHTML={{__html: footer.page_content.contentRaw}} />
      :
      null
      }

      <div className="footer-bottom">
  			<img src="/images/logo-billage-color.svg" alt="billage" className="billage-logo"/>

  			{/*<div className="btn-group sel-idioma dropdown">
  				<a href="#" className="btn btn-idioma dropbtn dropdown-toggle" >
  					Idioma:
  					<span className="lang-es">Español</span>
  					<span className="lang-en">English</span>
  					<span className="lang-ca">Català</span>

  					<i className="fa fa-angle-down" aria-hidden="true"></i>
  				</a>
          <div className="dropdown-content">
    				<ul>
    					<li><Link rel="alternate" hreflang="es" to="/es" className="lang_sel_sel icl-es">Español</Link></li>

    					<li><Link rel="alternate" hreflang="en" to="/en" className="lang_sel_sel icl-en">English</Link></li>

    					<li><Link rel="alternate" hreflang="ca" href="/ca" className="lang_sel_sel icl-ca">Català</Link></li>

    				</ul>
          </div>
  			</div>*/}
  		</div>
    </div>
  </footer>);
}


export default Footer
